import Api from './api';

export const getByContext = async (slaMode, parentId) => {
  let data = [];
  await Api.get(`/sla-priority?slaMode=${slaMode}&parentId=${parentId}`)
    .then(result => {
      data = result.data;
    })
    .catch(err => {
      data = err;
    });
  return data;
};

export const getActiveByHirer = async () => {
  let data = [];
  // timeout: chamada aguardada no carregamento das listas/acompanhamento — se a
  // API demorar, o axios rejeita, o catch assume e o cálculo segue o fluxo padrão
  await Api.get('/sla-priority/active', { timeout: 5000 })
    .then(result => {
      data = result.data;
    })
    .catch(err => {
      data = err;
    });
  return data;
};

export const sync = async (payload) => {
  let data = [];
  await Api.put('/sla-priority/sync', payload)
    .then(result => {
      data = result.data;
    })
    .catch(err => {
      data = err;
    });
  return data;
};
